if (window.location.href.indexOf("index") > -1 || window.location.origin) {
  document.getElementById("open-modal").click();
}
